import { render, staticRenderFns } from "./ImagesReview.vue?vue&type=template&id=7f31ff92"
import script from "./ImagesReview.vue?vue&type=script&lang=js"
export * from "./ImagesReview.vue?vue&type=script&lang=js"
import style0 from "./ImagesReview.vue?vue&type=style&index=0&id=7f31ff92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports